import { Component, Element, Event, EventEmitter, Host, Listen, Prop, State, h } from '@stencil/core';
import { isAlphabeticKey } from '../../utils/utils';
import { getLocalizedStrings } from '../../utils/utils';
import rpfDropdownStrings from './locales/translations.json';
@Component({
  tag: 'rpf-dropdown',
  styleUrl: 'rpf-dropdown.scss',
  shadow: true,
})
export class RpfDropdown {
  @Element() hostElement: HTMLElement;
  @Prop() locale: string = 'en-GB';
  @Prop() alignMenu: string = 'start';
  @Prop({ reflect: true }) theme: string;
  @Prop() selected?: string = '';
  @Prop() listBoxId: string;
  @State() isOpen = false;

  @Event({ eventName: 'isOpenChange' }) isOpenChange: EventEmitter<{ isOpen: boolean; char?: string }>;

  dropdownStrings: any;

  isOpenChangeHandler() {
    this.isOpenChange.emit({ isOpen: this.isOpen });
  }

  openWithAlphabeticKey(char: string) {
    this.isOpenChange.emit({ isOpen: this.isOpen, char });
  }

  @Listen('click', { target: 'window' })
  handleClick(ev) {
    if (ev.composedPath().includes(this.hostElement)) {
      this.isOpen = !this.isOpen;
    } else {
      this.isOpen = false;
    }
    this.isOpenChangeHandler();
  }

  @Listen('keydown')
  handleKeyDown(evt: KeyboardEvent) {
    const { key, altKey } = evt;
    const openKeys = ['ArrowDown', 'ArrowUp'];
    if (key === 'Escape' || (key === 'ArrowUp' && altKey)) {
      this.isOpen = false;
      this.isOpenChangeHandler();
    } else if (!this.isOpen && openKeys.includes(key)) {
      this.isOpen = true;
      this.isOpenChangeHandler();
    } else if (!this.isOpen && isAlphabeticKey(key)) {
      evt.stopPropagation();
      this.isOpen = true;
      this.openWithAlphabeticKey(key);
    }
  }

  @Listen('focusout')
  handleFocusOut(ev) {
    if (!this.hostElement.contains(ev.relatedTarget)) {
      this.isOpen = false;
    }
  }

  async componentWillRender() {
    this.dropdownStrings = getLocalizedStrings(this.locale, rpfDropdownStrings);
  }

  render() {
    return (
      <Host>
        <div class="rpf-dropdown">
          <button
            class={`rpf-dropdown__button ${this.isOpen ? 'rpf-dropdown__button--selected' : ''}`}
            aria-controls={this.listBoxId}
            aria-expanded={this.isOpen ? 'true' : 'false'}
            aria-haspopup="listbox"
            aria-activedescendant={this.isOpen ? this.selected : ''}
            role="combobox"
            aria-labelledby="button"
            title={this.dropdownStrings['toggle_menu_title']}
          >
            <slot name="button">OPEN MENU</slot>
          </button>
          <div class={`rpf-dropdown__menu rpf-dropdown__menu--align-${this.alignMenu} ${this.isOpen ? 'rpf-dropdown__menu--visible' : ''}`} role="listbox" id={this.listBoxId}>
            <slot />
          </div>
        </div>
      </Host>
    );
  }
}
